<template>
  <div>暂无加入的公司或分配的页面！</div>
</template>

<script>
export default {
  name: "appPrompt"
}
</script>

<style scoped>

</style>